<template>
  <div>
    <div class="tab-pane-body-other">
      <el-form ref="goodsIntroForm" :model="goodsInfo" :rules="goodsIntroRules" label-position="right" label-width="112px" >
        <el-form-item label="运费模板" prop="delivery_id">
          <el-input v-model="goodsInfo.delivery_id"></el-input>
        </el-form-item>
        <el-form-item label="商品状态" prop="status">
          <el-radio-group v-model="goodsInfo.status">
            <el-radio :label="10" border>上架</el-radio>
            <el-radio :label="20" border>下架</el-radio>  
          </el-radio-group>
        </el-form-item>
        <el-form-item label="初始销量" prop="sales_initial">
          <el-input-number v-model="goodsInfo.sales_initial" :step="100" :min="0" :max="100000000" controls-position="right"></el-input-number>
        </el-form-item>
        <el-form-item label="排序" prop="order">
          <el-input-number v-model="goodsInfo.order" :step="20" :min="0" :max="100000000" controls-position="right"></el-input-number>
        </el-form-item>
      </el-form>  
    </div>
  </div>
</template>

<script>
// 这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
import ApeEditor from '@/components/ApeEditor' 

export default {
  components: {
    ApeEditor
  },
  props: {
    // 信息
    goodsInfo: {
      type: Object,
      default() {
        return {}
      }
    },
  },
  // 定义属性
  data() {
    return {
      // 介绍规则
      goodsIntroRules: {
        delivery_id: [
          {required: true, message: '选择运费模板', trigger: 'change' },
        ],
        status: [
          {required: true, message: '选择商品状态', trigger: 'change' },
        ],
      },     
    }
  },
  // 方法集合
  methods: {
    // 处理编辑器内容输入
    handleTinymceInput(val) {
      this.goodsInfo.content = val
    },
    // 详情表单验证
    formValidate() {
      this.$refs['goodsIntroForm'].validate((valid) => {
        if (valid) {
          this.$emit('formSubmit',this.goodsInfo)
        } else {
          this.$message.error('数据验证失败，请检查必填项数据！')
        }
      })
    } 
  },
  // 生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {
  }
}
</script>

<style lang='stylus'>
  .tab-pane-body-other
    padding 16px
    width 60%
    .el-input-number
      width 100%
      .el-input__inner
        text-align left
</style>